import { motion } from 'framer-motion';
import { Trophy, Target, BookOpen, RefreshCw, Sparkles } from 'lucide-react';

// Map of icon name (returned by backend) -> Lucide component.
const ICONS = {
  Trophy,
  Target,
  BookOpen,
  RefreshCw,
  Sparkles,
};

// V2 Growth Cards — compact "your progress so far" metric strip.
// Sits between the Hero/Journey block and the active Mission card on Dashboard.
export default function GrowthCards({ cards }) {
  if (!Array.isArray(cards) || cards.length === 0) return null;
  return (
    <div className="mt-4" data-testid="growth-cards">
      <p className="text-[10px] uppercase font-extrabold text-[#AFAFAF] tracking-wider mb-2 pl-1">
        Your growth
      </p>
      <div className="grid grid-cols-2 gap-2">
        {cards.map((c, idx) => {
          const Icon = ICONS[c.icon] || Sparkles;
          return (
            <motion.div
              key={c.key}
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.25, delay: 0.05 * idx }}
              className="gm-card p-3 flex items-center gap-3"
              data-testid={`growth-card-${c.key}`}
            >
              <div
                className="w-9 h-9 rounded-2xl flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: `${c.color}1A` }}
              >
                <Icon size={18} color={c.color} strokeWidth={3} />
              </div>
              <div className="min-w-0">
                <p className="text-lg font-extrabold leading-none" data-testid={`growth-card-${c.key}-value`}>
                  {c.value}
                </p>
                <p className="text-[11px] uppercase font-extrabold text-[#4B4B4B] tracking-wide mt-0.5 leading-tight">
                  {c.label}
                </p>
                {c.sublabel && (
                  <p className="text-[10px] font-bold text-[#94A3B8] mt-0.5 leading-tight truncate">
                    {c.sublabel}
                  </p>
                )}
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
